import { LanguageType } from "@/custom-types";
import { PropertyTypeOption } from "@/graphql/generated";

export const propertyTypeMapper = (type: PropertyTypeOption, language: LanguageType) => {
  const texts = {
    en: {
      APARTMENT: 'Apartement',
      MULTI_FAMILY: 'Multy family',
      OTHER: 'Other',
      TOWN_HOUSE: 'Town House',
      UNIQUE: 'Unique',
    },
    es: {
      APARTMENT: 'Departamento',
      MULTI_FAMILY: 'Multi Familiar',
      OTHER: 'Otra',
      TOWN_HOUSE: 'Casa',
      UNIQUE: 'Unica',
    }
  }

  return texts[language][type]
}